const checkForWPTable = document.querySelector(`.schedule-container .table`);

if (checkForWPTable) {
  // Grab Table Header Values
  const scheduleTableHeaders = document.querySelectorAll(
    `.schedule-table-thead tr th`
  );

  // Array used to store the program names for populating the select drop down
  const scheduleDays = [];

  // Array used to store all the program names and populate them into filtering options
  const programNames = [];

  // Loops through all the schedule days and assign them to the scheduleDays array
  scheduleTableHeaders.forEach((header) => {
    scheduleDays.push(header.innerHTML);
  });

  // Add program names to the programNames array if they meet the specific requirements
  const addItemToArray = (item, programs) => {
    if (!programs.includes(item)) {
      programs.push(item);
      return;
    }
  };

  // Convert the programs names into valid kebab case ids/classes
  const convertProgramName = (program) => {
    return program
      .replace(/[^\w ]/, ``)
      .toLowerCase()
      .trim()
      .split(` `)
      .join(`-`);
  };

  /**
   * Loop through all the table cell's children and pull out the appropriate program names, then
   * send them to the addItmeArray function
   */
  const getProgramName = (cells) => {
    let childNodes = cells.childNodes;

    childNodes.forEach((node, i) => {
      if (node.nodeType === 1 && i === 0 && node.nodeName !== `BR`) {
        let convertedName = convertProgramName(node.textContent);
        node.parentElement.classList.add(convertedName);

        addItemToArray(node.textContent.trimEnd(), programNames);
      } else if (
        i === 0 &&
        !node.textContent.includes(` am`) &&
        i === 0 &&
        !node.textContent.includes(` pm`)
      ) {
        let convertedName = convertProgramName(node.textContent);
        node.parentElement.classList.add(convertedName);

        addItemToArray(node.textContent.trimEnd(), programNames);
      }
    });
  };

  // Iterate through all the cells of the table and send them to the getProgramName function
  const getRowData = (rows) => {
    rows.forEach((row) => {
      let tableCells = row.querySelectorAll(`td`);

      tableCells.forEach((cell) => {
        getProgramName(cell);
      });
    });
  };

  // Creates the filtering options buttons for desktop views.
  const createFilterButtons = () => {
    let filterContainer = document.querySelector(`.schedule-filter-container`);
    let programFilterContainer = document.createElement(`div`);
    programFilterContainer.classList.add(`schedule-program-name-filter`);
    filterContainer.appendChild(programFilterContainer);

    const programs = [...programNames.sort()];

    programs.forEach((program) => {
      let newButton = document.createElement(`button`);
      newButton.setAttribute(`type`, `button`);
      newButton.setAttribute(`id`, convertProgramName(program));
      newButton.classList.add(`schedule-filter-button`);
      newButton.innerHTML = program;
      programFilterContainer.appendChild(newButton);
    });
  };

  // Creates the "clear filters" button when filter options are present
  const createCloseButton = (span, rows, cells) => {
    let closeButton = span.querySelector(`button`);
    if (!closeButton) {
      let closeButton = document.createElement(`button`);
      closeButton.setAttribute(`id`, `schedule-clear-filters`);
      closeButton.innerHTML = `Clear Filters X`;
      span.appendChild(closeButton);

      clearFilterOption(closeButton, rows, cells);
    }
  };

  // Clears the filtering options when the "clear filters" button is clicked
  const clearFilterOption = (button, rows, cells) => {
    button.addEventListener(`click`, () => {
      rows.forEach((row) => {
        row.style.display = `table-row`;
      });
      cells.forEach((cell) => {
        cell.style.visibility = `visible`;
      });
      button.remove();
    });
  };

  // Creates a click event listener for all of the filter options buttons
  const programButtonFiltering = (rows, cells) => {
    const programButtons = document.querySelectorAll(`.schedule-filter-button`);
    const programFilterSpan = document.querySelector(
      `.schedule-filter-options span`
    );
    programButtons.forEach((button, i) => {
      button.addEventListener(`click`, () => {
        createCloseButton(programFilterSpan, rows, cells);

        rows.forEach((row) => {
          row.style.display = `none`;
        });

        cells.forEach((cell) => {
          if (cell.className === button.id) {
            cell.style.visibility = `visible`;
            cell.parentElement.style.display = `table-row`;
          } else {
            cell.style.visibility = `hidden`;
          }
        });
      });
    });
  };

  // Get current day and assign column to it
  const getCurrentDay = () => {
    let newDate = new Date();
    let mondayStartDate = newDate.getDay();
    // Shifts the index for the days date to a monday start date
    let todaysDate = mondayStartDate === 0 ? 6 : mondayStartDate - 1;
    return todaysDate;
  };

  // Sets which table header is the current day based on todays date
  const setDesktopActiveDay = () => {
    let dayIndex = getCurrentDay();
    scheduleTableHeaders.forEach((header, i) => {
      if (i === dayIndex) {
        header.classList.add(`today`);
      }
    });
  };

  // Set which days to hide based on day or selection
  const setMobileActiveDay = (day, today) => {
    let dayIndex = parseInt(day);
    scheduleTableHeaders.forEach((header, i) => {
      if (i !== dayIndex) {
        header.classList.remove(`today`);
        header.classList.add(`not-active`);
      } else {
        header.classList.remove(`not-active`);
        header.classList.add(`today`);
      }
    });

    scheduleTableRowData.forEach((row) => {
      let tableCells = row.querySelectorAll(`td`);

      tableCells.forEach((cell, i) => {
        if (i !== dayIndex) {
          cell.classList.remove(`empty-cell`);
          cell.classList.remove(`active`);
          cell.classList.add(`not-active`);
        } else if (cell.children.length === 0) {
          cell.classList.remove(`not-active`);
          cell.classList.add(`empty-cell`);
        } else {
          cell.classList.remove(`empty-cell`);
          cell.classList.remove(`not-active`);
          cell.classList.add(`active`);
        }
      });
    });
  };

  // Populates the selection drop down with the available days from the table header
  const setOptionValue = (selectionDropDown, today) => {
    for (i = 0; i < scheduleDays.length; i++) {
      let newOption = document.createElement(`option`);
      newOption.innerHTML = scheduleDays[i];
      newOption.value = i;
      selectionDropDown.appendChild(newOption);

      if (newOption.value === today.toString()) {
        newOption.setAttribute(`selected`, ``);
      }
    }
    setMobileActiveDay(today);
  };

  // Sets which day is currently selected based on the option
  const setOptionSelected = (selectedOption) => {
    let options = selectedOption.querySelectorAll(`option`);
    options.forEach((option, i) => {
      option.removeAttribute(`selected`);
      if (selectedOption.value === i.toString()) {
        option.setAttribute(`selected`, ``);
      }
    });
  };

  // Remove mobile specific classes when window size is bigger than 992px
  const removeTheadClasses = () => {
    scheduleTableHeaders.forEach((header, i) => {
      header.classList.remove(`today`);
      header.classList.remove(`not-active`);
      header.removeAttribute(`class`);
    });
  };

  const removeTbodyClasses = (rows) => {
    rows.forEach((row) => {
      let tableCells = row.querySelectorAll(`td`);
      tableCells.forEach((cell, i) => {
        cell.classList.remove(`active`);
        cell.classList.remove(`not-active`);
      });
    });
  };

  // Set the static table height so background image doesn't shift
  const setTableHeight = (table) => {
    table.style.height = ``;
    let height = table.clientHeight;
    table.style.height = height + `px`;
  };

  // Create laoding screen for the mobile schedule
  const displayScheduleLoadingScreen = (scheduleContainer) => {
    let loadingScreen = document.querySelector(`.schedule-loading-screen`);
    loadingScreen.classList.remove(`disabled`);
    loadingScreen.classList.add(`start-spin`);
    setTimeout(() => {
      loadingScreen.classList.add(`disabled`);
      loadingScreen.classList.remove(`start-spin`);
      scheduleContainer.classList.remove(`hidden`);
      scheduleContainer.classList.add(`visible`);
    }, 1000);
  };

  /**
   * Set initial option value
   */
  const scheduleTableRowData = document.querySelectorAll(
    `.schedule-table-tbody tr`
  );

  const scheduleTableCellData = document.querySelectorAll(
    `.schedule-table-tbody tr td`
  );

  const todaysDate = getCurrentDay();

  /**
   * Change active day based on input selection
   */

  const getWindowWidth = () => {
    const selectionDropDown = document.querySelector(`#schedule-table-select`);

    const scheduleFilters = document.querySelector(
      `.schedule-program-name-filter`
    );

    const scheduleTable = document.querySelector(
      `.schedule-container .wp-block-table`
    );

    const scheduleContainer = document.querySelector(`#schedule`);

    const screenWidth = window.innerWidth;

    if (screenWidth < 992 && selectionDropDown.children.length === 0) {
      displayScheduleLoadingScreen(scheduleContainer);
      removeTheadClasses();
      removeTbodyClasses(scheduleTableRowData);
      setOptionValue(selectionDropDown, todaysDate);

      selectionDropDown.addEventListener(`change`, (e) => {
        setMobileActiveDay(e.target.value);
        setOptionSelected(e.target);
        setTableHeight(scheduleTable);
      });

      setMobileActiveDay(todaysDate);
    } else if (screenWidth > 992 && !scheduleFilters) {
      removeTheadClasses();
      removeTbodyClasses(scheduleTableRowData);
      setDesktopActiveDay();
      getRowData(scheduleTableRowData, screenWidth);
      createFilterButtons();
      programButtonFiltering(scheduleTableRowData, scheduleTableCellData);
      setTableHeight(scheduleTable);
    }
    // else {
    //   removeTheadClasses();
    //   setDesktopActiveDay();
    //   removeTbodyClasses(scheduleTableRowData);
    //   setTableHeight(scheduleTable);
    // }
  };

  /**
   * Prevent resize event from calling too much based on resize
   */
  let timeout = false;
  window.addEventListener(`load`, getWindowWidth);
  window.addEventListener(`resize`, () => {
    clearTimeout(timeout);
    timeout = setTimeout(getWindowWidth, 500);
  });
}
